<template>
  <div
    v-for="(a, index) in fault_knowledge_value"
    v-show="!a.is_deleted"
    :key="index"
    :class="['row', index != 0 && 'mt-2', index != 0 && 'pt-4']"
    style="border-bottom: 1px dotted #f2f3f4"
  >
    <div class="d-flex" style="width: 68%">
      <div class="flex-grow-1 me-5">
        <div class="row">
          <div class="col-3">
            <div>
              <div>
                <span class="must-input" style="color: #f06548">* </span
                >{{ $t('Fault Type') }}
              </div>
              <div class="mt-2">
                <input
                :disabled='a.relation_type=="inherit"'
                  type="text"
                  :class="['form-control', a.nameType && 'is-invalid']"
                  maxlength="50"
                  v-model="a.name"
                  @input="
                    () => {
                      if (a.name.length == 0) {
                        fault_knowledge_value[index].nameType = true;
                      } else {
                        fault_knowledge_value[index].nameType = false;
                      }
                    }
                  "
                />
                <p v-show="a.nameType" style="color: #f06548; height: 20px">
                  {{ $t('page.fault.fault_classification_required') }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div>
              <div>{{ $t('page.fault.correlative_measuring_points') }}</div>
              <div class="mt-2">
                <el-cascader
                :disabled='a.relation_type=="inherit"'
                  v-model="a.measurements"
                  class="w-100"
                  :options="measurementList"
                  :props="props"
                  popper-class="x-model-form"
                  clearable
                ></el-cascader>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-10 mt-4">
      <div>{{ $t('page.fault.fault_description') }}</div>
      <div
        class="mt-2"
        style="
          border: 1px solid #f2f3f4;
          border-bottom: none;
          padding: 10px;
          padding-top: 0;
          padding-bottom: 0;
        "
      >
        <div
          class="row pt-2 pb-2"
          style="background: #f6f8fb; border-bottom: 1px solid #f2f3f4"
        >
          <div class="col-3">&nbsp;&nbsp;{{ $t('page.fault.fault_symptoms') }}</div>
          <div class="col-4">{{ $t('page.fault.fault_cause') }}</div>
          <div class="col-5">{{ $t('page.fault.resolution') }}</div>
        </div>
        <div
          v-for="(b, i) in a.description"
          v-show="!b.is_deleted"
          :key="i"
          class="row pt-2 pb-2"
          style="border-bottom: 1px solid #f2f3f4"
        >
          <div class="col-3">
            <textarea :disabled='a.relation_type=="inherit"'
              rows="1"
              class="form-control"
              maxlength="500"
              v-model="b.manifest"
            ></textarea>
          </div>
          <div class="col-4">
            <textarea :disabled='a.relation_type=="inherit"'
              rows="1"
              class="form-control"
              maxlength="500"
              v-model="b.cause"
            ></textarea>
          </div>
          <div class="col-5 position-relative">
            <textarea :disabled='a.relation_type=="inherit"'
              rows="1"
              class="form-control"
              maxlength="1000"
              v-model="b.solution"
            ></textarea>
            <b-button
            v-if="a.relation_type=='self'"
              class="position-absolute"
              variant="primary"
              size="sm"
              :style="{
                minWidth: '4.5rem',
                opacity: 1,
                right: '-5.5rem',
                top: '-5%',
              }"
              @click="tagMessageBox = `${index}-${i}`"
            >
              {{ $t("base.delete") }}
            </b-button>
            <MessageBox
              v-if="tagMessageBox == `${index}-${i}`"
              :messageCont="`${this.$t(
                'page.product-library.AreYouSureWantDelete'
              )}？`"
              :messageIcon="'ri-error-warning-line'"
              :iconStyle="{ fontSize: '14px', color: '#f06548' }"
              :messageStyle="{ top: '-6rem', left: '92%' }"
              @makeSure="delDescription(index, i)"
              @makeClose="tagMessageBox = null"
            ></MessageBox>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 d-flex justify-content-center mt-2 mb-4">
      <b-button
      v-if="a.relation_type=='self'"
        variant="primary"
        size="sm"
       
        :style="{
          minWidth: '4.5rem',
          opacity: 1,
        }"
        @click="addDescription(index)"
      >
        {{ $t('page.fault.add_fault_description') }}
      </b-button>
    </div>
  </div>
  <div class="w-100 mt-4 d-flex justify-content-center">
    <b-button
      variant="primary"
      size="mt-2 mb-2"
      :style="{
        minWidth: '4.5rem',
        opacity: 1,
      }"
      @click="addFault()"
    >
    {{ $t('page.fault.add_fault_information') }}
    </b-button>
  </div>
</template>

<script>
import MessageBox from "@/components/common/MessageBox.vue";

export default {
  emits: ["update:fault_knowledge"],
  props: {
    fault_knowledge: {
      type: Array,
      default: () => {
        return [];
      },
    },
    measurements: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  setup() {},
  data() {
    return {
      editFlag: true,
      dataTypes: [],
      measure: "",
      fault_knowledge_value: [],
      tagMessageBox: null,
      props: { multiple: true, emitPath: false, label: "name", value: "key" },
      options: [
        {
          value: 1,
          label: "东南",
        },
      ],
      measurementList: [],
    };
  },
  components: {
    MessageBox,
  },

  watch: {
    fault_knowledge_value: {
      handler(newVal) {
        console.log(newVal);
        this.$emit("update:fault_knowledge", newVal);
      },
      deep: true,
    },
    fault_knowledge: {
      handler(newVal) {
        this.fault_knowledge_value = newVal;
      },
      deep: true,
    },
    measurements: {
      handler(newVal) {
        console.log(newVal);
        this.measurementList = newVal;
            this.measurementList.map(item=>{
                item.disabled=false
            })
      },
      deep: true,
    },
  },
  methods: {
    delDescription(index, i) {
      if (
        this.fault_knowledge_value[index].description[i].is_deleted == false ||
        this.fault_knowledge_value[index].description[i].is_deleted == true
      ) {
        this.fault_knowledge_value[index].description[i].is_deleted = true;
        var type = this.fault_knowledge_value[index].description.every(
          (item) => {
            return item.is_deleted;
          }
        );
        console.log(type);
        if (type) {
          this.fault_knowledge_value[index].is_deleted = true;
        }
      } else {
        this.fault_knowledge_value[index].description.splice(i, 1);
        if (this.fault_knowledge_value[index].description.length == 0) {
          this.fault_knowledge_value.splice(index, 1);
        }
      }
      console.log(this.fault_knowledge_value);
    },
    addDescription(index) {
      this.fault_knowledge_value[index].description.push({
        manifest: "",
        cause: "",
        solution: "",
      });
    },
    addFault() {
      this.fault_knowledge_value.push({
        name: "",
        measurements: [],
        description: [],
        relation_type:"self"
      });
    },
    delFault(index) {
      this.fault_knowledge_value.splice(index, 1);
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
p {
  margin: 0;
}
</style>
<style>
.x-model-form label.el-checkbox {
  margin-bottom: 0 !important;
}
</style>